(function(angular){
    'use strict';

    /**********************************************************************
     * The report list service performs any API interactions required
     * by the report list component.
     *********************************************************************/
    angular.module('bmrcReportListService', [])
        .service('bmrcReportListService', ['$http', '$q', function ($http, $q) {
        var srv = this;
        srv.getReportListQuery = null;
        srv.securedReportPreviewUrlQuery = null;
        srv.securedReportDownloadUrlQuery = null;
        srv.sendReportToOnvioDocumentsUrlQuery = null;
        srv.sendReportToBinderDocumentsUrlQuery = null;
        srv.getSelectedFolder = null;
        srv.getUseNewAsyncMode = null;
        srv.getProcessCreateDocumentRequestToSocketSrv = null;
        srv.getSocketServicePromise = null;
        srv.getCreateDocumentApipromise = null;
        srv.createDocumentRequestUrl = null;
        srv.closeSocketConnection = null;
        srv.insertIntoSocketSrvTracing = null;

        var getToolbarFilterComboValue = function () {
            if (srv.toolbarFilterCombo) {
                var filterValue = srv.toolbarFilterCombo.value;
                if (filterValue && !filterValue.id && angular.isString(filterValue)) {
                    return { id: filterValue };
                }
                return filterValue;
            }
            return undefined;
        };

        srv.setProcessCreateDocumentRequestToSocketSrv = function (processCreateDocumentFunction) {
            srv.getProcessCreateDocumentRequestToSocketSrv = processCreateDocumentFunction;
        };

        srv.setUseNewAsyncMode = function(value){
            srv.getUseNewAsyncMode = value;
        };

        srv.setSocketServicePromise = function (socketServicePromise) {
            srv.getSocketServicePromise = socketServicePromise;
        };

        srv.setCreateDocumentApipromise = function (createDocumentApipromise) {
            srv.getCreateDocumentApipromise = createDocumentApipromise;
        };

        srv.setCloseSocketConnection = function (closeSocketConnection) {
            srv.closeSocketConnection = closeSocketConnection;
        };

        srv.setInsertIntoSocketSrvTracing = function (insertIntoSocketSrvTracing) {
            srv.insertIntoSocketSrvTracing = insertIntoSocketSrvTracing;
        };

        /**********************************************************************
         * Set the query to use when loading the report list. As this may
         * require loading data, this is taken as a promise.
         *********************************************************************/
        srv.setReportListQuery = function(query) {
            srv.getReportListQuery = query;
        };

        /**********************************************************************
         * Set the url to use to get a secured preview report url. As the url may
         * require loading data, this is taken as a promise.
         *********************************************************************/
        srv.setSecuredReportPreviewUrl = function(query) {
            srv.securedReportPreviewUrlQuery = query;
        };

        /**********************************************************************
         * Set the url to use to get a secured report (for downloading) url. As the url may
         * require loading data, this is taken as a promise.
         *********************************************************************/
        srv.setSecuredReportDownloadUrl = function(query) {
            srv.securedReportDownloadUrlQuery = query;
        };

        /**********************************************************************
         * Set the url to use to get a url for generating a report that is then sent to onvio documents. As the url may
         * require loading data, this is taken as a promise.
         *********************************************************************/
        srv.setSendReportToOnvioDocumentsUrl = function(query) {
            srv.sendReportToOnvioDocumentsUrlQuery = query;
        };

        /**********************************************************************
         * Set the url to use to get a url for generating a report that is then sent to binder documents. As the url may
         * require loading data, this is taken as a promise.
         *********************************************************************/
        srv.setSendReportToBinderDocumentsUrl = function(query) {
            srv.sendReportToBinderDocumentsUrlQuery = query;
        };

        /**********************************************************************
         * Set the url to use to get a secured report (for downloading) url. As the url may
         * require loading data, this is taken as a promise.
         *********************************************************************/
         srv.setCreateDocumentRequestUrl = function (query) {
            srv.createDocumentRequestUrl = query;
        };

        /**********************************************************************
         * Load the report list.
         *********************************************************************/
        srv.getList = function(params) {
            if (!srv.getReportListQuery) {
                throw new Error('Get list cannot be called until the setReportListQuery method has set the required function.');
            }
            var filterValue = getToolbarFilterComboValue();
            return srv.getReportListQuery(params, filterValue);
        };

        /**********************************************************************
         * Loads the secured preview report url.
         *********************************************************************/
        srv.getSecuredReportPreviewUrl = function(item) {
            if (!srv.securedReportPreviewUrlQuery) {
                throw new Error('Get secured report preview url cannot be called until the setSecuredReportPreviewUrl method has set the required url promise.');
            }
            var filterValue = getToolbarFilterComboValue();
            return srv.securedReportPreviewUrlQuery(filterValue, item).then(function(url) {
                if(url.indexOf('simple-auth:') !== -1) {
                    return $http({ url: url.replace('simple-auth:', ''), method: 'GET', responseType: 'arraybuffer', params: {}, headers: {} }).then(function(response) {
                        if (response) {
                            if (response.status && response.status >= 400) {
                                return $q.reject(response);
                            }
                            if (response.data && response.headers) {
                                console.log('creating blob file from', response);
                                var file = new Blob([response.data], { type: response.headers()['content-type'] });
                                var fileUrl = URL.createObjectURL(file); // Generate a 'blob:' link
                                return fileUrl;
                            } else {
                                return null;
                            }
                        }
                    });
                } else {
                    return $http({ url: url, method: 'POST', params: {}, headers: {} }).then(function(response) {
                        if (response) {
                            if (response.status && response.status >= 400) {
                                return $q.reject(response);
                            }
                            if (response.data) {
                                if (response.data.hasOwnProperty('Url')) {
                                    return response.data.Url;
                                }
                                if (response.data.hasOwnProperty('url')) {
                                    return response.data.url;
                                }
                                return null;
                            } else {
                                return null;
                            }
                        }
                        return null;
                    });
                }
            });
        };

        /**********************************************************************
         * Loads the secured preview report url for async.
         *********************************************************************/
        srv.getSecuredReportPreviewUrlForAsync = function (item, jobId) {
        if (!srv.securedReportPreviewUrlQuery) {
            throw new Error('Get secured report preview url async cannot be called until the setSecuredReportPreviewUrl method has set the required url promise.');
        }
        var filterValue = getToolbarFilterComboValue();
        return srv.securedReportPreviewUrlQuery(filterValue, item).then(function(url) {
            return $http({ url: url, method: 'POST', params: {}, headers: {} }).then(function(response) {
                if (response) {
                    if (response.status && response.status >= 400) {
                        return $q.reject(response);
                    }
                    if (response.data) {
                        if (response.data.hasOwnProperty('url')) {
                            var url = response.data.url;
                            if (!url.match(/^blob:/)) {
                                url = url + '&jobId=' + jobId;
                            }
                            window.open(url, '_blank');
                            return true;
                        }
                        return null;
                    } else {
                        return null;
                    }
                }
                return null;
            });
        });
    };

        /**********************************************************************
         * Returns Job Id for the requested file generation.
         *********************************************************************/
        srv.postCreateDocumentRequest = function (body, publishToSocketServices = false) {
            if (!srv.createDocumentRequestUrl) {
                throw new Error('Post Create Document Request cannot be called until the setCreateDocumentRequestUrl method has set the required url promise.');
            }
            return srv.createDocumentRequestUrl().then(function (url) {
                return $http({ url: url, method: 'POST', data: body, params: {}, headers: {} }).then(function(response) {
                    if (response.data) {
                        if (response.data.hasOwnProperty('jobId')) {
                            if (publishToSocketServices) {
                                srv.insertIntoSocketSrvTracing(response.data.jobId, body);
                                srv.getProcessCreateDocumentRequestToSocketSrv(response.data.jobId, true);
                            }
                            return response.data.jobId;
                        }
                        return null;
                    } else {
                        return null;
                    }
                });
            });
        };

        /**********************************************************************
         * Loads the secured downloadable report url.
         *********************************************************************/
        srv.getSecuredReportDownloadUrl = function(item) {
            if (!srv.securedReportDownloadUrlQuery) {
                throw new Error('Get secured report download url cannot be called until the setSecuredReportDownloadUrl method has set the required url promise.');
            }
            var filterValue = getToolbarFilterComboValue();
            return srv.securedReportDownloadUrlQuery(filterValue, item).then(function(url) {
                if(url.indexOf('simple-auth:') !== -1) {
                    return url;
                } else {
                    return $http({ url: url, method: 'POST', params: {}, headers: {} }).then(function(response) {
                        if (response) {
                            if (response.status && response.status >= 400) {
                                return $q.reject(response);
                            }
                            if (response.data) {
                                if (response.data.hasOwnProperty('Url')) {
                                    return response.data.Url;
                                }
                                if (response.data.hasOwnProperty('url')) {
                                    return response.data.url;
                                }
                                return null;
                            } else {
                                return null;
                            }
                        }
                        return null;
                    });
                }
            });
        };

        /**********************************************************************
         * Loads the secured downloadable report url async.
         *********************************************************************/
         srv.getSecuredReportDownloadUrlAsync = function(item, body) {
            if (!srv.securedReportDownloadUrlQuery) {
                throw new Error('Get secured report download url async cannot be called until the setSecuredReportDownloadUrl method has set the required url promise.');
            }
            var filterValue = getToolbarFilterComboValue();
            return srv.securedReportDownloadUrlQuery(filterValue, item).then(function(url) {
                    return $http({ url: url, method: 'POST', data: body, responseType: 'arraybuffer', params: {}, headers: {} });
            });
        };

        /**********************************************************************
         * Gets the url for sending reports to URL
         *********************************************************************/
        srv.getSendReportToOnvioDocumentsUrl = function(item) {
            if (!srv.sendReportToOnvioDocumentsUrlQuery) {
                throw new Error('Get send report to Onvio url cannot be called until the setSecuredReportDownloadUrl method has set the required url promise.');
            }
            var filterValue = getToolbarFilterComboValue();
            return srv.sendReportToOnvioDocumentsUrlQuery(filterValue, item);
        };

        /**********************************************************************
         * Gets the url for sending reports to URL async
         *********************************************************************/
         srv.getSendReportToOnvioDocumentsUrlAsync = function(item, body) {
            if (!srv.sendReportToOnvioDocumentsUrlQuery) {
                throw new Error('Get send report to Onvio url cannot be called until the setSecuredReportDownloadUrl method has set the required url promise.');
            }
            var filterValue = getToolbarFilterComboValue();
            return srv.sendReportToOnvioDocumentsUrlQuery(filterValue, item).then(function(url) {
                return $http({ url: url, method: 'POST', data: body, params: {}, headers: {} });
            });
        };

        /**********************************************************************
         * Gets the url for sending reports to binder documents
         *********************************************************************/
        srv.getSendReportToBinderDocumentsUrl = function(item) {
            if (!srv.sendReportToBinderDocumentsUrlQuery) {
                throw new Error('Get send report to binder documents url cannot be called until the setSendReportToOnvioDocumentsUrl method has set the required url promise.');
            }
            var filterValue = getToolbarFilterComboValue();
            return srv.sendReportToBinderDocumentsUrlQuery(filterValue, item).then(function(url) {
                return url;
            });
        };

        /**********************************************************************
         * Set the callback to use to get a selected onvio documents folder. As the callback may
         * require loading data, this is taken as a promise.
         *********************************************************************/
        srv.setGetSelectedFolder = function(query) {
            srv.getSelectedFolder = query;
        };

        /**********************************************************************
         * Gets the selected folder
         *********************************************************************/
        srv.getGetSelectedFolder = function() {
            if (!srv.getSelectedFolder) {
                throw new Error('Get selected folder cannot be called until the setSelectedFolder method has set the required callback promise.');
            }

            return srv.getSelectedFolder();
        };
    }]);
})(window.angular);
